import { render, staticRenderFns } from "./CommonDropzoneWithAvatarUpload.vue?vue&type=template&id=4c5d6299&lang=pug&"
import script from "./CommonDropzoneWithAvatarUpload.vue?vue&type=script&lang=ts&"
export * from "./CommonDropzoneWithAvatarUpload.vue?vue&type=script&lang=ts&"
import style0 from "./CommonDropzoneWithAvatarUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports